module.exports = __webpack_public_path__ + "static/media/gatsby.ef07d2f4.png";